<template>
  <div>
    <div class="title">
      <span style="cursor: pointer" @click="$router.go(-1)">订单管理</span>
      > <span>订单详情</span>
    </div>
    <div>
      <div class="order_Box">
        <div>订单信息</div>
        <div class="order_information">
          <div class="order_column">
            <div>
              <span class="order_key">订单编号</span>
              <span>{{ orderinformation.order_child_sn }}</span>
            </div>
            <div>
              <span class="order_key">用户昵称</span>
              <span>{{ orderinformation.userName }}</span>
            </div>
            <div>
              <span class="order_key">订单生成时间</span>
              <span>{{ orderinformation.created_at }}</span>
            </div>
            <div>
              <span class="order_key">订单状态</span>
              <span>{{
                orderinformation.status == 1
                  ? "未支付"
                  : orderinformation.status == 2
                  ? "待发货"
                  : orderinformation.status == 3
                  ? "待收货"
                  : orderinformation.status == 4
                  ? "评价"
                  : orderinformation.status == 5
                  ? "已取消"
                  : orderinformation.status == 6
                  ? "已完成"
                  : orderinformation.status == 7
                  ? "支付失败"
                  : ""
              }}</span>
            </div>
          </div>
          <div class="order_column">
            <div>
              <span class="order_key">订单类型</span>
              <span>{{ orderinformation.order_child_sn }}</span>
            </div>
            <div>
              <span class="order_key">用户账号</span>
              <span>{{ orderinformation.mobilePhone }}</span>
            </div>
            <div>
              <span class="order_key">支付时间</span>
              <span>{{ orderinformation.pay_at }}</span>
            </div>
            <div>
              <span class="order_key">结算状态</span>
              <span>{{ orderinformation.settlement_status }}</span>
            </div>
          </div>
          <div class="order_column">
            <div>
              <span class="order_key">订单完成时间</span>
              <span>{{ orderinformation.complete_time }}</span>
            </div>
            <div>
              <span class="order_key">是否团长</span>
              <span> </span>
            </div>
            <div>
              <span class="order_key">交易单号</span>
              <span> </span>
            </div>
            <div>
              <span class="order_key">是否开票</span>
              <span> </span>
            </div>
          </div>
        </div>
      </div>
      <div class="Order_Details_Box">
        <div>订单明细</div>
        <div style="margin-top: 20px">
          <el-table ref="table" :data="orderinformation.goods" :summary-method="getummaries" border show-summary style="width: 100%" :header-cell-style="{ background: '#F5F6FA' }">
            <el-table-column align="center" prop="id" label="ID" width="180"> </el-table-column>
            <el-table-column align="center" prop="title" label="商品名称"> </el-table-column>
            <el-table-column align="center" prop="sku_id" label="商品ID"> </el-table-column>
            <el-table-column align="center" prop="thumb" label="图片">
              <template slot-scope="scope">
                <img :src="scope.row.thumb" alt="" style="width: 50px" />
              </template>
            </el-table-column>
            <el-table-column align="center" label="规格">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.orderRowinfo" :key="index" style="display: flex; flex-direction: column">
                  <div>
                    <span>{{ item.name }} :</span><span>{{ item.value }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="price" label="单价"> </el-table-column>
            <!-- <el-table-column prop=""  label="拼团价"> </el-table-column> -->
            <el-table-column align="center" prop="sku_num" label="数量"> </el-table-column>
            <el-table-column align="center" prop="price_order" label="商品总价"> </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="order_Notes_Box">
        <div style="margin-bottom: 20px">物流信息</div>
        <el-table :data="expresslist" style="margin-bottom: 20px" border :header-cell-style="{ background: '#F5F6FA' }">
          <el-table-column prop="name" label="收件人姓名" align="center" width="140"></el-table-column>
          <el-table-column prop="mobile" align="center" label="联系电话" width="180"></el-table-column>
          <el-table-column prop="addressDetail" label="收件地址" align="center"></el-table-column>
          <el-table-column prop="receivingTime" label="收件时间" align="center" width="180"></el-table-column>
        </el-table>

        <el-table
          v-if="packageInfo.length > 0"
          :data="packageInfo"
          style="margin-bottom: 20px"
          border
          show-summary
          :summary-method="getSummariesExpress"
          :header-cell-style="{ background: '#F5F6FA' }"
        >
          <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
          <el-table-column prop="name" align="center" label="包裹信息"></el-table-column>
          <el-table-column prop="waybillNo" label="物流单号" align="center"></el-table-column>
          <el-table-column prop="logisticsCompanyName" label="物流品牌" align="center" width="100"></el-table-column>
          <el-table-column prop="senderAddress" label="发货仓" align="center"></el-table-column>
          <el-table-column prop="freight" label="物流费用" align="center" width="100"> </el-table-column>
          <el-table-column align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="handleButton(scope.row)">物流查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="order_Notes_Box">
        <div style="margin-bottom: 20px">优惠卡券</div>
        <el-table :data="coponInfo" style="margin-bottom: 20px" border show-summary :summary-method="getSummariesC" :header-cell-style="{ color: '#000000' }" :cell-style="{ borderColor: ' #FACD91' }">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label=" 优惠商品名称" width="140" :show-overflow-tooltip="true" prop="goods_name"></el-table-column>
          <el-table-column label="卡券类别" width="140" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.type == 1 ? "满减券" : scope.row.type == 2 ? "叠加满减券" : scope.row.type == 3 ? "无门槛券" : "折扣券" }}
            </template>
          </el-table-column>
          <el-table-column label="卡券名称" width="100" prop="title"> </el-table-column>
          <el-table-column label=" 卡券编号" width="100" :show-overflow-tooltip="true" prop="serial_no"></el-table-column>
          <el-table-column label="卡券金额" :show-overflow-tooltip="true" prop="with_amount"></el-table-column>
          <el-table-column label=" 抵扣金额" :show-overflow-tooltip="true" prop="used_amount"></el-table-column>
        </el-table>
      </div>
      <div class="order_Notes_Box">
        <div>订单备注</div>
        <div class="order_Notes_center">{{ orderinformation.remark }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      orderinformation: {}, //订单信息
      orderRowinfo: [], //订单信息
      packageInfo: [], //物流信息
      expresslist: [], //物流数组
      coponInfo: [] //优惠券的数据
    };
  },
  created() {
    this.getOrderDeta();
  },
  mounted() {},
  methods: {
    ...mapActions({
      getBeiOrderDetails: "commodity/getBeiOrderDetails", //修改成为北京查询列表的详情接口
      getBeiOrderDetailAddress: "commodity/getBeiOrderDetailAddress" //修改成为北京查询列表的详情接口
    }),
    getLogisticsBaseInfo() {
      let par = {
        orderNo: this.orderinformation.order_child_sn
      };
      this.getBeiOrderDetailAddress(par)
        .then(res => {
          if (res.code == 10000) {
            if (res.data) {
              this.packageInfo.push(res.data.packageInfo);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {});
    },
    getummaries(param) {
      //订单明细的合计方法
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0 || index === 1 || index === 2 || index === 3 || index === 4 || index === 5 || index === 6) {
          sums[index] = "合计 :";
          return;
        }
        const values = data.map(item => {
          if (column.property === "price_order") {
            return Number(item[column.property]);
          }
        });
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = String(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "  ";
        } else {
          sums[index] = " ";
        }
      });
      this.$nextTick(() => {
        //合并订单吗清晰最后一行
        if (this.$refs.table.$el) {
          var current = this.$refs.table.$el.querySelector(".el-table__footer-wrapper").querySelector(".el-table__footer");
          var tds = current.rows[0].cells;
          tds[0].colSpan = "7"; // 前四行都显示累计
          tds[0].style.textAlign = "right"; // 前四行都显示累计
          tds[0].style.paddingRight = "20px";
          tds[1].style.display = "none";
          tds[2].style.display = "none";
          tds[3].style.display = "none";
          tds[4].style.display = "none";
          tds[5].style.display = "none";
          tds[6].style.display = "none";
        }
      });
      return sums;
    },
    getSummariesExpress(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 5) {
          const values = data.map(item => Number(item[column.property]));

          sums[1] = values.reduce((prev, curr) => {
            return prev + curr;
          }, 0);
          sums[1] = sums[1].toFixed(2);
        }
      });
      return sums;
    },
    getSummariesC(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 5) {
          sums[index] = "合计";
          return;
        }
        if (index === 6) {
          const values = data.map(item => Number(item[column.property]));
          sums[6] = values.reduce((prev, curr) => {
            return prev + curr;
          }, 0);
          sums[6] = sums[6].toFixed(2);
        }
      });
      return sums;
    },
    getOrderDeta() {
      //获取订单详情数据
      let data = {
        id: this.$route.query.orderID
      };
      this.getBeiOrderDetails(data).then(res => {
        console.log("this.orderinformation :>> ", res);
        if (res.code === 0) {
          res.data.goods.forEach(element => {
            if (element.json) {
              let iten = JSON.parse(element.json);
              element.orderRowinfo = iten.goods_attributes;
            }
          });
          this.coponInfo = res.data.coponInfo;
          let reg = /^(.{3}).*(.{4})$/;
          let wuliuname;
          wuliuname = res.data.receivers_names.substring(0, 1);
          for (let index = 0; index < res.data.userName.length; index++) {
            wuliuname = wuliuname + "**";
          }
          let eobj = {
            name: wuliuname,
            mobile: res.data.receivers_phone.replace(reg, "$1****$2"),
            // res.data.receivers_address
            addressDetail: "**********",
            receivingTime: "-"
          };
          this.expresslist.push(eobj);
          this.orderinformation = res.data;
          console.log("this.orderinformation :>> ", this.orderinformation);
          let name = "";
          name = this.orderinformation.userName.substring(0, 1);
          for (let index = 0; index < this.orderinformation.userName.length; index++) {
            name = name + "*";
          }
          this.orderinformation.userName = name;
          this.orderinformation.mobilePhone = this.orderinformation.mobilePhone.replace(reg, "$1****$2");
          if (res.data.status == 3) {
            this.getLogisticsBaseInfo();
          }
          // let arr=[]
          // res.data.goods.forEach(element => {
          //   if(element.json){
          //     let iten=JSON.parse(element.json)
          //     console.log('object :>> ', iten);
          //     arr.push(iten.goods_attributes)
          //   }
          // });
          // this.orderRowinfo= arr.flat(Infinity)
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  width: 100%;
  background: #fff;
  font-size: 18px;
  color: #333;
  padding: 15px 32px;
}
.Order_Details_Box {
  background-color: #fff;
  margin: 0 24px;
  padding: 20px 30px;
}
.order_Notes_Box {
  background-color: #fff;
  margin: 0 24px;
  padding: 20px 30px;
  .order_Notes_center {
    margin-top: 20px;
    width: 100%;
    font-size: 18px;
    min-height: 80px;
    color: #333;
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  }
}
.order_Box {
  // width: 100%;
  background-color: #fff;
  margin: 24px 24px 0 24px;
  padding: 20px 30px;
  .order_information {
    display: flex;
    justify-content: flex-start;
    background: #fff;
    width: 100%;
    padding-left: 20px;
    // box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    .order_column {
      flex: 1;
      line-height: 50px;
      .order_key {
        width: 100px;
        text-align: center;
        display: inline-block;
      }
    }
  }
}
</style>
